class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        
        this.addEventListener("click", (event) => {  
            event.preventDefault();

            this.closest("cart-items")
                .updateQuantity(this.dataset.index, 0)
                .then(async () => {
                   await this.updateExtraOptions();
                });
        });
    }

    async updateExtraOptions() {
        const options = JSON.parse(this.dataset.properties.replace(new RegExp("'", "g"), '"'));
        const elementQtyToDelete = this.dataset.variant_qty;
        for (const option of options) {
            if (option[0].includes("option")) {
                const variantId = option[1];
            
                const variantEl = document.querySelector(`[data-variant_id="${variantId}"]`);
                if (variantEl) {
                    const cartItems = variantEl.closest("cart-items");
                    const response = await cartItems.updateQuantity(
                        variantEl.dataset.line,
                        parseInt(variantEl.dataset.variant_qty) - elementQtyToDelete
                    );

                }
            }
        }
     

    }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
    constructor() {
        super();

        this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status");

        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
            (total, quantityInput) => total + parseInt(quantityInput.value),
            0
        );

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener("change", this.debouncedOnChange.bind(this));
    }

    onChange(event) {
      if(event.srcElement.classList.contains('ajaxdyorupdate') == false && event.srcElement.classList.contains('ajaxPropertyUpdate') == false && event.srcElement.classList.contains('size_main_selector_property') == false){
      this.updateQuantity(
            event.target.dataset.index,
            event.target.value,
            document.activeElement.getAttribute("name")
        );
      }
    }

    getSectionsToRender() {
        return [
            {
                id: "main-cart-items",
                section: document.getElementById("main-cart-items").dataset.id,
                selector: ".js-contents",
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
            },
            {
                id: "cart-live-region-text",
                section: "cart-live-region-text",
                selector: ".shopify-section",
            },
            {
                id: "main-cart-footer",
                section: document.getElementById("main-cart-footer").dataset.id,
                selector: ".js-contents",
            },
        ];
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);
        var gemstone_ring = $(`.jtpl_cart_page_cstm #CartItem-${line}[data-gemstone_ring='true']`).length;
        var engrave_product = $(`.jtpl_cart_page_cstm #CartItem-${line}[data-engrave_product='true']`).length;
        var gemstone_rendom_no = $(`.jtpl_cart_page_cstm #CartItem-${line}[data-gemstone_ring='true']`).attr('data-rendom_no');
        var engrave_rendom_no = $(`.jtpl_cart_page_cstm #CartItem-${line}[data-engrave_product='true']`).attr('data-rendom_no');
        var qty = quantity;
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        });
        
        return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
              
                const parsedState = JSON.parse(state);
                this.classList.toggle("is-empty", parsedState.item_count === 0);
                  if(parsedState.item_count == 0){
                    $(this).parents('.cart_container').addClass('is-empty_cstm');
                  }
                const cartFooter = document.getElementById("main-cart-footer");
                if (cartFooter) cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section) => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) ||
                        document.getElementById(section.id);

                    elementToReplace.innerHTML = this.getSectionInnerHTML(
                        parsedState.sections[section.section],
                        section.selector
                    );
                });
                 if(gemstone_ring >0 || engrave_product >0){
                 var id = $('.jtpl_cart_page_cstm .cart-item[data-rendom_no="'+gemstone_rendom_no+'"]').attr('data-key');
                   if(engrave_product >0 ){
                  var id = $('.jtpl_cart_page_cstm .cart-item[data-rendom_no="'+engrave_rendom_no+'"]').attr('data-key');
                   }
                let url = window.Shopify.routes.root+"cart";
                 var quantity = qty;
                 var body1 = {quantity:qty, id:id};
                $.ajax({
                method: "POST",
                dataType: 'json',
                url:'/cart/change.js',
                async: false,
                data:body1,
                success: function(data) {
                  window.location.href = url; 
                },
                error:function(response){
                return false;
                }
                }); 
                }
               $.ajax({
                      type: 'GET',
                      url: '/cart',
                      cache: false,
                      async:false,
                      dataType: 'html',
                      success: function(cart) {
                        console.log(cart);
                        $('.cart__footer').html($(cart).find('.cart__footer').html());
                        $('.jtpl-custom-cart-drawer').html($(cart).find('.jtpl-custom-cart-drawer').html());
                        $('.jtpl-custom-cart-drawer #CartDrawer').html($(cart).find('.jtpl-custom-cart-drawer #CartDrawer').html());
                        $('.custom_cart_drawer').css('top','128px');
                        $('.cart-count-bubble').html($(cart).find('.cart-count-bubble').html())
                         var flag = 0;
                        $('#idcart #CartDrawer-CartItems .cart-items .cart-item').each(function(){
                         var p_title =  $(this).attr('data-product-title');
                          var count = 0;
                           if(p_title != undefined){
                          $('#idcart #CartDrawer-CartItems .cart-items .cart-item').each(function(index){
                               var sp_title =  $(this).attr('data-product-title');
                              if(sp_title == p_title){
                                count = count+1;
                                  if(count >1){
                                      flag = 1;
                                  var _thisattr = $(this).attr('data-product-title');
                                      var _this = this; 
                                  }
                              }
                           })
                          }
                      })
                      if(flag ==  0){
                          $('.cart__checkout-button,.cart__ctas button#Checkout').removeClass('hidden');
                           $('.cart__checkout-button,.cart__ctas button#Checkout').attr('disabled',false);
                         $('.cart__ctas button#CartDrawer-Checkout').removeClass('hidden');
                            $('.cart__ctas button#CartDrawer-Checkout').attr('disabled',false);
                      }
                        document.dispatchEvent(new CustomEvent("swym:cart-loaded"));
                      }
                  });
                this.updateLiveRegions(line, parsedState.item_count);
                const lineItem = document.getElementById(`CartItem-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`))
                    lineItem.querySelector(`[name="${name}"]`).focus();
                    recalculateCartLines();
                    this.disableLoading();
               
               
              })
            .catch((e) => {
                this.querySelectorAll(".loading-overlay").forEach((overlay) => overlay.classList.add("hidden"));
                document.getElementById("cart-errors").textContent = window.cartStrings.error;
          
                this.disableLoading();
            });
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            document.getElementById(`Line-item-error-${line}`).querySelector(".cart-item__error-text").innerHTML =
                window.cartStrings.quantityError.replace(
                    "[quantity]",
                    document.getElementById(`Quantity-${line}`).value
                );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute("aria-hidden", true);

        const cartStatus = document.getElementById("cart-live-region-text");
        cartStatus.setAttribute("aria-hidden", false);

        setTimeout(() => {
            cartStatus.setAttribute("aria-hidden", true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        document.getElementById("main-cart-items").classList.add("cart__items--disabled");
        this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) =>
            overlay.classList.remove("hidden")
        );
        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }

    disableLoading() {
        document.getElementById("main-cart-items").classList.remove("cart__items--disabled");
    }
}

customElements.define("cart-items", CartItems);


